import { connect } from 'react-redux';
import { IRootState } from '../../redux/state';
import { IUser } from '../../models';
import PdaSettingsAdminPage from './PdaSettingsAdminPage';
import { bindActionCreators, Dispatch } from 'redux';
import { getPdaSettings } from '../../redux/modules/pdaSettings/pdaSettingsCreators';

function mapStateToProps(state: IRootState) {
  return {
    impersonatedUser: state.authentication.impersonatedUser,
    authentication: state.authentication as unknown as IUser,
    pdaSettingsList: state.pdaSettings.pdaSettingList,
    isLoading: state.pdaSettings.isLoading,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    getPdaSettings: bindActionCreators(getPdaSettings, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PdaSettingsAdminPage);
